import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Keyboard } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/keyboard";
import "./hero.css";
import { CoverSlide } from "../types";
import { useNavigate } from "react-router-dom";

interface SwipperProps {
  slidesData: CoverSlide[];
}

// Gallery hero: artwork panel left, info panel right. The art is never
// cropped (object-fit: contain); the stage behind it is a blurred,
// color-matched copy of the artwork itself.
const Swipper: React.FC<SwipperProps> = ({ slidesData }) => {
  const navigate = useNavigate();

  return (
    <Swiper
      pagination={{ clickable: true }}
      modules={[Pagination, Autoplay, Keyboard]}
      keyboard={{ enabled: true, onlyInViewport: true }}
      spaceBetween={24}
      slidesPerView={1}
      loop={slidesData.length > 1}
      autoplay={{ delay: 5000, disableOnInteraction: false }}
      className="heroSwipper"
    >
      {slidesData.map((slide, index) => (
        <SwiperSlide key={slide?._id || index}>
          <div
            className="heroGallery__slide"
            onClick={() => navigate(`/details/${slide?._id}`)}
            role="button"
            tabIndex={0}
            aria-label={slide?.title}
          >
            <div className="heroGallery__stage">
              {slide?.backgroundImage ? (
                <>
                  <div
                    className="heroGallery__backdrop"
                    style={{
                      backgroundImage: `url(${slide.backgroundImage})`,
                    }}
                  />
                  <img
                    className="heroGallery__art"
                    src={slide.backgroundImage}
                    alt={slide?.title || ""}
                    loading="eager"
                  />
                </>
              ) : null}
            </div>
            <div className="heroGallery__content">
              <span className="heroGallery__kicker">Featured</span>
              <h2 className="heroGallery__title">{slide?.title}</h2>
              {slide?.description2 && (
                <div className="heroGallery__meta">{slide.description2}</div>
              )}
              {slide?.description && (
                <p className="heroGallery__desc">{slide.description}</p>
              )}
              <button
                type="button"
                className="heroGallery__cta"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/details/${slide?._id}`);
                }}
              >
                <span>View artwork</span>
                <i className="bi bi-arrow-right" aria-hidden="true" />
              </button>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Swipper;
